import React from 'react';

const ErrorComponent: React.FunctionComponent = () => {
    return <p>There is no market found </p>;
};

export default ErrorComponent;
